export default __webpack_public_path__ + "static/media/Group316@2x.1363d355.png";